<template>
  <v-container v-if="localizedData" class="py-15">
    <h2 class="heading text-center">{{ localizedData.outline.heading }}</h2>
    <v-row class="justify-center mt-4">
      <v-col id="outline" cols="12" sm="6" class="text-left">
        <ul class="" style="list-style: none;">
          <li class="mt-8">
            <h3 class="text-body-1 text-sm-h6 font-weight-bold" v-html="localizedData.outline.name"></h3>
            <p class="mt-2 text-body-2 text-sm-body-1" v-html="localizedData.outline.name_text"></p>
          </li>
          <li class="mt-8">
            <h3 class="text-body-1 text-sm-h6 font-weight-bold" v-html="localizedData.outline.period"></h3>
            <p class="mt-2 text-body-2 text-sm-body-1" v-html="localizedData.outline.period_text"></p>
            <p class="mt-2 text-caption text-note" v-html="localizedData.outline.period_note"></p>
          </li>
          <li class="mt-8">
            <h3 class="text-body-1 text-sm-h6 font-weight-bold" v-html="localizedData.outline.time"></h3>
            <p class="mt-2 text-body-2 text-sm-body-1" v-html="localizedData.outline.time_text"></p>
          </li>
          <li class="mt-8">
            <h3 class="text-body-1 text-sm-h6 font-weight-bold" v-html="localizedData.outline.place"></h3>
            <p class="mt-2 text-body-2 text-sm-body-1" v-html="localizedData.outline.place_text"></p>
          </li>
          <li class="mt-8">
        <v-row align="center">
          <v-col cols="12" md="auto">
            <h3 class="text-body-1 text-sm-h6 font-weight-bold" v-html="localizedData.outline.price"></h3>
          </v-col>
          <v-col cols="12" md="8">
            <v-btn 
                    class="agency-button text-body-2 mt-0"
                    rounded="xl"
                    size="large"
                    variant="outlined"
                    target="_self"
                    :href="localizedData.outline.price_url"
                    v-smooth-scroll
                    >
              {{ localizedData.outline.price_button }}
              <SvgIcon type="mdi" :path="mdiChevronRight" size="16" />
            </v-btn>
          </v-col>
        </v-row>
          </li>
          <li class="mt-8">
            <h3 class="text-body-1 text-sm-h6 font-weight-bold">{{ localizedData.outline.contact }}</h3>
            <p class="mt-2 mb-0 text-pre-wrap text-body-2 text-sm-body-1" v-html="localizedData.outline.contact_text"></p>
            <p class="mt-0 text-pre-wrap text-body-2 text-sm-body-1 mt-6" v-html="localizedData.outline.contact_text2"></p>
          </li>
        </ul>
      </v-col>
      <v-col id="access" cols="12" sm="6" class="text-left mt-8">
        <h3 class="text-body-1 text-sm-h6 font-weight-bold" v-html="localizedData.access.heading"></h3>

        <iframe
          :src="(localizedData.access.map)"
          class="mt-2"
          width="100%"
          height="300"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
        <p class="text-body-2 text-sm-body-1 text-pre-wrap mt-6" v-html="localizedData.access.lead"></p>
        <v-row align="center" class="mt-6">
          <v-col cols="12" md="auto">
            <h3 class="text-body-1 text-sm-h6 font-weight-bold">{{ localizedData.access.title }}</h3>
          </v-col>
          <!-- <v-col cols="12" md="9" class="display-none">
            <v-btn target="_blank" class="bg-white" rounded light :href="localizedData.access.parking_url" style="text-transform: none">
              {{ localizedData.access.parking_button }}
              <SvgIcon type="mdi" :path="mdiOpenInNew" size="16" />
            </v-btn>
          </v-col> -->
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" sm="12">
            <p class="text-body-2 text-sm-body-1 text-pre-wrap" v-html="localizedData.access.dd1"></p>
          </v-col>
          <v-col cols="12" sm="12">
            <p class="text-body-2 text-sm-body-1 text-pre-wrap" v-html="localizedData.access.dd2"></p>
          </v-col>
          <v-col cols="12">
            <p class="text-body-2 text-sm-body-1 text-pre-wrap" v-html="localizedData.access.dd3"></p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { mdiChevronRight, mdiOpenInNew } from '@mdi/js';
import SvgIcon from '@jamescoyle/vue-icon';

import localeData from '@/locales/OutlineAccess';

const { t, locale } = useI18n();
const localizedData = computed(() => localeData[locale.value]);

</script>

<style>
.agency-button {
    border-width: 2px;
}
</style>